import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
// import { CSVLink } from 'react-csv'
import { Link } from 'react-router-dom'
import InputTextButton from '../../input/InputTextButton'
import FeatherIcon from 'feather-icons-react'
import { InputRangeDatePicker } from '../../../components/Main'
import DownloadCSV from '../../extras/DownloadCSV'

const WideCardFilter = (data) => {
  // const pathSegments = window.location.pathname.split('/')
  const { filter, payload, getData, loading, buttonCheckSaldo } = data
  const { t } = useTranslation()
  const [payloadFilter, setPayloadFilter] = useState(payload)
  const [query, setQuery] = useState('')
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  // turn the raw string into an array
  const raw = payloadFilter.keywords.status || ''
  const statuses = raw ? raw.split('|') : []

  // close dropdown on outside click
  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('click', onClickOutside)
    return () => document.removeEventListener('click', onClickOutside)
  }, [])

  // options filtered by query
  const options = filter?.status?.options
    ?.filter((opt) => opt.label.toLowerCase().includes(query.toLowerCase()))
    .slice(0, 10)

  // toggles a value in the string list
  const handleStatusChange = (e) => {
    const clicked = e.target.value
    const next = statuses.includes(clicked)
      ? statuses.filter((v) => v !== clicked)
      : [...statuses, clicked]
    const newStatus = next.join('|') // '' | 'A' | 'A|B'
    const newPayload = {
      ...payloadFilter,
      page: 1,
      keywords: { ...payloadFilter.keywords, status: newStatus },
    }
    data.handleFilter(newPayload)
    setPayloadFilter(newPayload)
  }

  const handleTextSearch = (e) => {
    setPayloadFilter({
      ...payloadFilter,
      keywords: {
        ...payloadFilter.keywords,
        text_search: e.target.value,
      },
    })
  }

  const handleClearSearch = () => {
    let objPayload = { ...payloadFilter }
    objPayload.page = 1
    objPayload.keywords.text_search = ''
    data.handleFilter(objPayload)
    setPayloadFilter(objPayload)
  }
  const handleSearch = (e) => {
    e.preventDefault()
    let objPayload = { ...payloadFilter }
    objPayload.page = 1
    data.handleFilter(objPayload)
    setPayloadFilter(objPayload)
  }
  const handleStatus = (e) => {
    e.preventDefault()
    let objPayload = { ...payloadFilter }
    objPayload.page = 1
    objPayload.keywords.status = e.target.value
    data.handleFilter(objPayload)
    setPayloadFilter(objPayload)
  }

  const handlePaymentStatus = (e) => {
    e.preventDefault()
    let objPayload = { ...payloadFilter }
    objPayload.page = 1
    objPayload.keywords.payment_status = e.target.value
    data.handleFilter(objPayload)
    setPayloadFilter(objPayload)
  }
  const handlePaymentType = (e) => {
    e.preventDefault()
    let objPayload = { ...payloadFilter }
    objPayload.page = 1
    objPayload.keywords.payment_type = e.target.value
    data.handleFilter(objPayload)
    setPayloadFilter(objPayload)
  }
  const handleAddressType = (e) => {
    e.preventDefault()
    let objPayload = { ...payloadFilter }
    objPayload.page = 1
    objPayload.keywords.address_type = e.target.value
    data.handleFilter(objPayload)
    setPayloadFilter(objPayload)
  }
  const handleDatePicker = (e) => {
    const newPayload = {
      ...payloadFilter,
      page: 1,
      keywords: {
        ...payloadFilter.keywords,
        date_start: e.start,
        date_end: e.end,
      },
    }
    data.handleFilter(newPayload)
    setPayloadFilter(newPayload)
  }

  return (
    <>
      <div className={filter ? 'row mb-3 flex-column flex-md-row ml-2' : 'd-none'}>
        <div className="d-flex flex-wrap align-items-center w-100">
          <div className="d-flex flex-wrap flex-grow-1 align-items-center">
            {filter?.text_search && (
              <InputTextButton
                value={payloadFilter.keywords.text_search}
                placeholder={data.label_input}
                onChange={handleTextSearch}
                onSubmit={handleSearch}
                onClear={handleClearSearch}
                className="mt-2"
              />
            )}
            {filter?.payment_type && (
              <div className="row col-12 col-md-3 mr-2 mt-xs-0 mt-md-2 mt-lg-2">
                <select
                  className="form-control height-40 py-2 px-3"
                  name="status"
                  required
                  value={payloadFilter.keywords.payment_type}
                  onChange={handlePaymentType}
                >
                  {filter.payment_type.map((row, index) => {
                    return (
                      <option key={index} value={row.value}>
                        {row.label}
                      </option>
                    )
                  })}
                </select>
              </div>
            )}
            {filter?.payment_status && (
              <div className="row col-12 col-md-3 mr-2 mt-2 mt-lg-2">
                <select
                  className="form-control height-40 py-2 px-3"
                  name="payment_status"
                  required
                  value={payloadFilter.keywords.payment_status}
                  onChange={handlePaymentStatus}
                >
                  {filter.payment_status.map((row, index) => {
                    return (
                      <option key={index} value={row.value}>
                        {row.label}
                      </option>
                    )
                  })}
                </select>
              </div>
            )}
            {filter?.status &&
              (filter?.status?.multiple ? (
                <div className="position-relative mt-2 mr-4" ref={ref}>
                  <div
                    className="form-control d-flex flex-wrap align-items-center px-3 py-2"
                    style={{
                      cursor: 'text',
                      minWidth: '200px',
                      maxWidth: '300px',
                      height: 'auto',
                    }}
                    onClick={() => setOpen(true)}
                  >
                    {statuses.map((val) => {
                      const opt = filter.status.options.find((o) => o.value === val)
                      return (
                        <span
                          key={val}
                          className="badge bg-primary d-flex align-items-center rounded-pill text-white"
                          style={{
                            margin: '2px',
                            padding: '0em 0.75em',
                            minHeight: 25,
                            alignSelf: 'center',
                            transform: 'translateY(-2px)',
                            marginRight: 5,
                          }}
                        >
                          {opt?.label || val}
                          <FeatherIcon
                            icon="x"
                            size={14}
                            className="ms-1"
                            style={{
                              cursor: 'pointer',
                              marginLeft: 5,
                              transform: 'translateY(-2px)',
                            }}
                            onClick={(e) => {
                              e.stopPropagation()
                              handleStatusChange({ target: { value: val } })
                            }}
                            aria-label="Remove"
                          />
                        </span>
                      )
                    })}

                    <input
                      type="text"
                      className="border-0 text-left flex-none w-24"
                      placeholder={t('title.select_status')}
                      value={query}
                      onFocus={() => setOpen(true)}
                      onChange={(e) => {
                        setQuery(e.target.value)
                        setOpen(true)
                      }}
                    />
                  </div>

                  {open && (
                    <ul
                      className="list-group position-absolute w-100 mt-1"
                      style={{
                        zIndex: 1000,
                        maxHeight: 200,
                        overflowY: 'auto',
                        borderRadius: 10,
                      }}
                    >
                      {options.map((item) => {
                        const isSel = payloadFilter.keywords.status.includes(item.value)
                        return (
                          <li
                            key={item.value}
                            className={`list-group-item d-flex justify-content-between align-items-center${
                              isSel ? ' list-group-item-secondary' : ''
                            }`}
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleStatusChange({ target: { value: item.value } })}
                          >
                            <span className={isSel ? 'text-blue' : ''}>{item.label}</span>
                            {isSel && <span className="text-white">✓</span>}
                          </li>
                        )
                      })}
                    </ul>
                  )}
                </div>
              ) : (
                <div className="row col-12 col-md-3 mr-2 mt-2 mt-lg-2 ">
                  <select
                    className="form-control height-40 py-2 px-3"
                    name="status"
                    required
                    value={payloadFilter.keywords.status}
                    onChange={handleStatus}
                  >
                    <option value="">{t('title.select_status')}</option>
                    {filter?.status?.options?.map((row, idx) => (
                      <option key={idx} value={row.value}>
                        {row.label}
                      </option>
                    ))}
                  </select>
                </div>
              ))}
            {filter?.address_type && (
              <div className="row col-12 col-md-3 mr-2 mt-2 mt-lg-2">
                <select
                  className="form-control height-40 py-2 px-3"
                  name="address_type"
                  required
                  value={payloadFilter.keywords.address_type}
                  onChange={handleAddressType}
                >
                  {filter.address_type.map((row, index) => {
                    return (
                      <option key={index} value={row.value}>
                        {row.label}
                      </option>
                    )
                  })}
                </select>
              </div>
            )}

            {filter?.dateRange && (
              <div className="d-flex align-items-center mt-2 mr-3" style={{ minWidth: '400px' }}>
                <InputRangeDatePicker
                  initial="DDMMYY"
                  changeYear={true}
                  onCallback={handleDatePicker}
                  maxDate={new Date()}
                  startDate={payloadFilter.keywords.date_start}
                  endDate={payloadFilter.keywords.date_end}
                  preventManuallyType={true}
                  radius="border-radius-20"
                />
              </div>
            )}
            {filter?.download && (
              <div className="d-inline-flex align-items-center me-2 mt-2 mt-lg-2">
                <DownloadCSV filter={filter} getData={getData} loading={loading} />
              </div>
            )}
            {/* {filter?.download && !implemented.includes(pathSegments[1]) && (
          <div className="d-inline-flex align-items-center me-2 mt-2 mt-lg-2">
            {filter.download?.data && (
              <CSVLink
                data={filter.download.data}
                headers={filter.download.headers}
                filename={filter.download.filename}
                separator=";"
                className="btn btn-primary btn-xs text-nowrap px-2 py-1"
              >
                <i className="fa fa-download" /> {t('button.download_csv')}
              </CSVLink>
            )}
          </div>
        )} */}
          </div>
          {buttonCheckSaldo && (
            <div className="pr-4 d-flex align-items-center">
              <Link
                to={'/return/check-saldo'}
                className="d-inline btn rounded-pill btn-primary btn-xs m-2 font-size-12"
              >
                <span className="mr-2">{t('button.check_return_saldo')}</span>
                <i className="fas fa-arrow-circle-right"></i>
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default WideCardFilter
